import React from "react";

// The SEUTRADE gold corporate seal rendered AS a revolving 3D holographic sphere.
// A bold engraved "SEUTRADE FINANCIAL SERVICES" banner clearly revolves
// around the equator; iridescent holo sheen + shimmer + shaded gold ball give it
// depth. Legend sits ABOVE the holo so it always stays readable.
const PHRASE = "SEUTRADE FINANCIAL SERVICES   ·   ";
const equator = PHRASE.repeat(6);
const faint = PHRASE.repeat(6);

export const GlobeSeal = () => (
  <div className="stf-seal" data-testid="landing-globe-seal" aria-label="Seutrade Financial Services revolving seal">
    <div className="stf-sphere">
      {/* gold surface + meridian grid + faint text */}
      <div className="stf-surface">
        <div className="stf-grid" />
        <div className="stf-band stf-faint">{faint}</div>
        <div className="stf-band stf-faint stf-faint-b">{faint}</div>
      </div>
      {/* holographic sheen (under the legend) */}
      <div className="stf-holo" />
      <div className="stf-holo2" />
      {/* prominent revolving legend — the corporation name */}
      <div className="stf-equator">
        <div className="stf-legend">{equator}</div>
      </div>
      {/* 3D shading + highlights on top */}
      <div className="stf-terminator" />
      <div className="stf-sweep" />
      <div className="stf-shine" />
      <div className="stf-rim" />
    </div>
    <div className="stf-badge">EST · 2025</div>

    <style>{`
      .stf-seal{ position:relative; width:210px; height:210px; margin:0 auto 10px;
        display:flex; align-items:center; justify-content:center;
        filter: drop-shadow(0 10px 26px rgba(0,0,0,.7)); }
      .stf-sphere{ position:relative; width:196px; height:196px; border-radius:50%;
        overflow:hidden; isolation:isolate;
        background: radial-gradient(circle at 36% 30%, #C9A03A 0%, #A57E1C 24%, #6f5310 52%, #3f2e07 78%, #120b00 100%);
        box-shadow: inset -22px -18px 50px rgba(0,0,0,.85),
                    inset 10px 8px 22px rgba(210,170,70,.35); }

      .stf-surface{ position:absolute; inset:0; z-index:1; }
      .stf-grid{ position:absolute; inset:0; opacity:.45;
        background:
          repeating-linear-gradient(90deg, transparent 0 30px, rgba(94,68,6,.5) 30px 31px),
          repeating-linear-gradient(0deg, transparent 0 22px, rgba(94,68,6,.3) 22px 23px); }
      .stf-band{ position:absolute; white-space:nowrap; font-family:Georgia,'Times New Roman',serif;
        font-weight:700; letter-spacing:2px; color:#2a1f04; text-shadow:0 1px 0 rgba(200,160,60,.35); }
      .stf-faint{ top:24%; left:0; font-size:11px; opacity:.35; animation: stf-revolve 17s linear infinite; }
      .stf-faint-b{ top:70%; opacity:.28; animation: stf-revolve 21s linear infinite; }

      .stf-holo{ position:absolute; inset:0; border-radius:50%; z-index:2; pointer-events:none;
        mix-blend-mode: color-dodge; opacity:.30; filter: saturate(1.3) brightness(1.05);
        background: conic-gradient(from 0deg,#ff3db1,#ff6a00,#ffe000,#5cff6a,#00f0ff,#3d6bff,#c14bff,#ff3db1);
        -webkit-mask: radial-gradient(circle at 50% 50%, #000 0 52%, transparent 74%);
                mask: radial-gradient(circle at 50% 50%, #000 0 52%, transparent 74%);
        animation: stf-holo-rot 9s linear infinite, stf-hue 5s linear infinite; }
      .stf-holo2{ position:absolute; inset:0; border-radius:50%; z-index:2; pointer-events:none;
        mix-blend-mode: screen; opacity:.22; filter: saturate(1.4) brightness(1.0);
        background: conic-gradient(from 180deg,#00f0ff,#7cff00,#ffe000,#ff5ad6,#00f0ff);
        -webkit-mask: radial-gradient(circle at 50% 50%, #000 0 48%, transparent 70%);
                mask: radial-gradient(circle at 50% 50%, #000 0 48%, transparent 70%);
        animation: stf-holo-rev 12s linear infinite, stf-hue 7s linear infinite reverse; }

      /* prominent revolving name banner across the equator — bright gold band, black letters */
      .stf-equator{ position:absolute; top:50%; left:0; width:100%; height:32px; z-index:3;
        transform: translateY(-50%); overflow:hidden;
        background: linear-gradient(180deg, rgba(255,225,150,0) 0%, rgba(230,190,90,.92) 22%, rgba(250,220,140,.98) 50%, rgba(230,190,90,.92) 78%, rgba(255,225,150,0) 100%);
        box-shadow: inset 0 1px 0 rgba(255,248,214,.7), inset 0 -1px 0 rgba(80,54,0,.6); }
      .stf-legend{ position:absolute; top:50%; left:0; white-space:nowrap;
        font-family:Georgia,'Times New Roman',serif; font-weight:800; font-size:15px; letter-spacing:2.5px;
        color:#0A0A0A; text-shadow: 0 1px 0 rgba(255,248,214,.5);
        animation: stf-legend-move 14s linear infinite; }

      .stf-terminator{ position:absolute; inset:0; border-radius:50%; z-index:4; pointer-events:none;
        background:
          radial-gradient(circle at 50% 50%, rgba(0,0,0,0) 42%, rgba(10,7,0,.65) 82%, rgba(0,0,0,.95) 100%),
          linear-gradient(118deg, rgba(0,0,0,0) 40%, rgba(0,0,0,.55) 90%); }
      .stf-sweep{ position:absolute; inset:0; border-radius:50%; z-index:5; pointer-events:none;
        mix-blend-mode: screen; opacity:.32;
        background: linear-gradient(60deg, transparent 36%, rgba(255,225,150,.5) 50%, rgba(210,170,70,.25) 56%, transparent 70%);
        background-size:250% 250%; animation: stf-sweep-move 5.5s ease-in-out infinite; }
      .stf-shine{ position:absolute; top:8%; left:14%; width:44%; height:38%; z-index:6; border-radius:50%;
        pointer-events:none; filter:blur(3px);
        background: radial-gradient(circle at 32% 30%, rgba(255,238,190,.55), rgba(255,238,190,0) 68%); }
      .stf-rim{ position:absolute; inset:0; border-radius:50%; z-index:7; pointer-events:none;
        box-shadow: 0 0 22px 6px rgba(0,0,0,.85) inset, 0 0 14px 2px rgba(150,110,30,.25);
        animation: stf-rim-glow 6s ease-in-out infinite; }
      .stf-badge{ position:absolute; bottom:-4px; left:50%; transform:translateX(-50%); z-index:8;
        font-family:Georgia,serif; font-size:8px; letter-spacing:2px; color:#0A0A0A; background:#B8860B;
        padding:2px 10px; border-radius:9px; text-transform:uppercase; white-space:nowrap;
        box-shadow:0 2px 8px rgba(0,0,0,.45); }

      @keyframes stf-revolve{ from{ transform: translateX(0);} to{ transform: translateX(-50%);} }
      @keyframes stf-legend-move{ from{ transform: translate(0,-50%);} to{ transform: translate(-50%,-50%);} }
      @keyframes stf-holo-rot{ to{ transform: rotate(360deg);} }
      @keyframes stf-holo-rev{ to{ transform: rotate(-360deg);} }
      @keyframes stf-hue{ to{ filter: hue-rotate(360deg);} }
      @keyframes stf-sweep-move{ 0%{background-position:0% 0%;} 50%{background-position:100% 100%;} 100%{background-position:0% 0%;} }
      @keyframes stf-rim-glow{ 0%,100%{ box-shadow:0 0 22px 6px rgba(0,0,0,.85) inset,0 0 12px 1px rgba(150,110,30,.2);} 50%{ box-shadow:0 0 26px 7px rgba(0,0,0,.9) inset,0 0 18px 3px rgba(180,140,50,.35);} }
      @media (prefers-reduced-motion: reduce){ .stf-faint,.stf-legend,.stf-holo,.stf-holo2,.stf-sweep,.stf-rim{ animation:none; } }
    `}</style>
  </div>
);

export default GlobeSeal;
